<template>
  <div class="senses" id="select-sense">
    <Select2 @select="select($event)" :settings="selectConfig" ref="select2" tabindex="0" />
  </div>
</template>

<script>
  import Select2 from 'v-select2-component'
  import config from '@/config.js'
  import $ from 'jquery'

  export default {
    name: 'SenseSelect',
    props: ['exclude', 'sense'],
    components: {
      Select2
    },
    mounted() {
      if (this.sense){
        this.$refs.select2.select2.append(
          `<option selected value="${this.sense.id}">${this.sense.definition}</option>`
        ).trigger('change')
      }
    },
    data() {
      return {
        query: ''
      }
    },
    computed: {
      selectConfig(){
        return {
          placeholder: "Select a sense",
          // allowClear: true,
          width: '100%',
          templateResult: this.formatOption,
          dropdownParent: "#select-sense",
          minimumInputLength: 3,
          ajax: {
            delay: 250,
            url: config.apiUrl + '/senses/autocomplete',
            headers: config.apiHeaders,
            data: (params) => {
              this.query = params.term
              return {
                query: params.term,
                exclude: JSON.stringify(this.exclude),
              }
            },
            processResults: (data) => {
              data.push({
                id: -2,
                display: `Create new <b>${this.query}</b>`
              })
              return {
                results: data.map(sense => {
                  return {
                    id: sense.id,
                    text: sense.display,
                    sense: sense
                  }
                })
              }
            }
          }
        }
      }
    },
    methods: {
      select(event){
        if (event.selected && event.id == -2){
          this.$emit('selectNew', this.query)
        }
        else{
          this.$emit('select', event.selected ? event.sense : null)
        }
      },
      formatOption(item) {
        return $(`<span>${item.text}</span>`)
      }
    }
  }
</script>
